import React from 'react';
import {observer} from 'mobx-react';
import ReactDOM from "react-dom";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";

export interface SnackbarNotificationContainerComponentProps extends ComponentServicesPick<'notifications' | 'dom'> {

}

const ComponentBody :React.FC<SnackbarNotificationContainerComponentProps> = observer((props) => {

    if(props.notifications.currentNotificationsComponents.length === 0) {
        return null;
    }

    return (
        <>
            {props.notifications.currentNotificationsComponents.map(notification => ReactDOM.createPortal(notification, props.dom.body))}
        </>
    );
});

export const SnackbarNotificationContainerComponent = withServices(ComponentBody, ["notifications", "dom"]);